// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GrantCategory_Wrapper__bzrq9"};